import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatErr } from "../../lib/api";

const STATUSES = ["pending", "approved", "rejected", "completed"];

export default function AdmRefunds() {
  const [list, setList] = useState([]);
  const refresh = () => api.get("/admin/refunds").then(r=>setList(r.data));
  useEffect(()=>{ refresh(); }, []);
  const upd = async (r, status) => {
    try { await api.put(`/admin/refunds/${r.id}`, { status, admin_note: r._note||"" }); toast.success("Updated"); refresh(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  return (
    <div className="space-y-6">
      <div><div className="overline mb-2">Customer Care</div><h1 className="font-display text-4xl text-white">Refunds & Exchanges</h1></div>
      <div className="space-y-3">
        {list.map(r => (
          <div key={r.id} className="card-luxe p-5">
            <div className="flex justify-between items-start mb-2">
              <div>
                <div className="overline">{r.type}</div>
                <div className="font-display text-lg text-white mt-1">{r.name}</div>
                <div className="text-xs text-white/50">{r.email} · {r.mobile} · Order: {r.order_id||"—"}</div>
              </div>
              <span className={`text-[10px] uppercase tracking-luxe px-2 py-1 ${r.status==="approved"||r.status==="completed"? "bg-[#32D74B]/10 text-[#32D74B]":(r.status==="rejected"?"bg-red-400/10 text-red-400":"bg-copper/10 text-copper")}`}>{r.status}</span>
            </div>
            <p className="text-sm text-white/70 mt-2">{r.message}</p>
            {r.admin_note && <div className="text-xs text-white/50 italic mt-2">Note: {r.admin_note}</div>}
            <div className="text-xs text-white/40 mt-2">{new Date(r.created_at).toLocaleString()}</div>
            <div className="mt-3 flex gap-2 items-end flex-wrap">
              <input placeholder="Note (optional)" className="input-box text-xs flex-1 min-w-[200px]" onChange={(e)=>{r._note=e.target.value;}}/>
              {STATUSES.map(s => <button key={s} onClick={()=>upd(r, s)} className={`text-xs uppercase tracking-luxe px-3 py-2 border ${r.status===s? "border-copper text-copper":"border-white/15 text-white/70 hover:text-white"}`}>{s}</button>)}
            </div>
          </div>
        ))}
        {list.length === 0 && <div className="card-luxe p-10 text-center text-white/40">No requests yet</div>}
      </div>
    </div>
  );
}
